import { c as _c } from "react/compiler-runtime";
import { CompetitionsPageLoading } from '@/components/social/competition/competitions-list-boundaries';
export default function CompetitionsLoading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CompetitionsPageLoading />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}